
exports.constants = {
  'DEBUG_STYLE_1' : 'background-color: #aaa022; color: #222222;',
  'DEBUG_STYLE_2' : 'background-color: #7c3b8e; color: #ffffff;',
  'DEBUG_STYLE_3' : 'background-color: #3a696b; color: #eeeeee;',
}
